/**
 * 车队管理
 * @author xingzb
 * @date 2020-1-7
 */
import request from "@/utils/request";

// 新增实际承运人上报
export function updateAuthStatus(query) {
  return request({
    url: `/ntocc-basic-api/driver/sendCyrCountryPlatformm`,
    method: "get",
    params: query
  });
}

// 获取 车队列表
export function getDriverTeamList(query) {
  return request({
    url: "/ntocc-basic-api/driver",
    // url: '/ntocc-basic-api/driver/taxDriverAuthList',
    method: "get",
    params: query
  });
}

// 获取 车队列表
export function getUpDriverList(query) {
  return request({
    url: "/ntocc-basic-api/driver/getUpDriverList",
    // url: '/ntocc-basic-api/driver/taxDriverAuthList',
    method: "get",
    params: query
  });
}

// 天津获取司机上报
export function tianjinReportDriverInfo(data) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportDriverInfo",
    // url: '/ntocc-thirdparty-api/driver/taxDriverAuthList',
    method: "post",
    data
  });
}
// 天津获取车辆上报
export function tianjinReportVehicleInfo(data) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportVehicleInfo",
    // url: '/ntocc-thirdparty-api/driver/taxDriverAuthList',
    method: "post",
    data
  });
}
// 天津获取路单上报
export function tianjinReportTransportWaybill(query) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportTransportWaybill",
    // url: '/ntocc-thirdparty-api/driver/taxDriverAuthList',
    method: "put",
    params: query
  });
}
// 天津获取资金上报
export function reportTransportFund(query) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportTransportFund",
    // url: '/ntocc-thirdparty-api/driver/taxDriverAuthList',
    method: "put",
    params: query
  });
}
// 获取 车队列表
export function getUpVehicleList(query) {
  return request({
    url: "/ntocc-basic-api/driver/getUpVehicleList",
    // url: '/ntocc-basic-api/driver/taxDriverAuthList',
    method: "get",
    params: query
  });
}

// 获取 车队列表
export function getCarListTeamList(query) {
  return request({
    url: "/ntocc-basic-api/driver/carList",
    // url: '/ntocc-basic-api/driver/taxDriverAuthList',
    method: "get",
    params: query
  });
}
export function getCarList(query) {
  return request({
    url: "/ntocc-basic-api/vehicle",
    // url: '/ntocc-basic-api/driver/taxDriverAuthList',
    method: "get",
    params: query
  });
}
// 获取 车队列表
export function getDriverTeamListAuth(query) {
  return request({
    // url: '/ntocc-basic-api/driver',
    url: "/ntocc-basic-api/driver/taxDriverAuthList",
    method: "get",
    params: query
  });
}

// 新增 车队
export function addDriverTeam(query) {
  return request({
    url: `/ntocc-basic-api/driver/save`,
    method: "post",
    data: query
  });
}

// 获取 指定车队信息
export function getDriverTeam(code) {
  return request({
    url: `/ntocc-basic-api/driver/${code}`,
    method: "get"
  });
}
// 获取 指定车队信息
export function getVehicleTeam(code) {
  return request({
    url: `/ntocc-basic-api/vehicle/${code}`,
    method: "get"
  });
}

//司机审核弹窗信息
export function authInfo(query) {
  return request({
    url: `/ntocc-basic-api/driver/authInfo`,
    method: "post",
    params: query
  });
}

//司机审核
export function driverAuth(query) {
  return request({
    url: `/ntocc-basic-api/driver/driverAuth`,
    method: "post",
    params: query
  });
}

//车辆审核弹窗信息
export function authCarInfo(query) {
  return request({
    url: `/ntocc-basic-api/driver/authCarInfo`,
    method: "get",
    params: query
  });
}

//车辆审核
export function carAuth(query) {
  return request({
    url: `/ntocc-basic-api/driver/carAuth`,
    method: "post",
    params: query
  });
}

// 更新 指定车队
export function updateAddOrDriverTeam(query) {
  return request({
    url: `/ntocc-basic-api/vehicle/addOrUpdate`,
    method: "post",
    params: query
  });
}

// 更新 指定车队
export function updateDriverTeam(query) {
  return request({
    url: `/ntocc-basic-api/driver/update`,
    method: "put",
    data: query
  });
}

// 删除 指定车队/司机
export function delDriverTeam(query) {
  return request({
    url: `/ntocc-basic-api/driver/batchDel`,
    method: "delete",
    params: query
  });
}

// 获取 司机列表
export function getTeamDriverList(query) {
  return request({
    url: "/ntocc-basic-api/driver/teamDriverList",
    method: "get",
    params: query
  });
}

// 获取 指定司机
export function getTeamDriver(code) {
  return request({
    url: `/ntocc-basic-api/driver/teamDriverList/${code}`,
    method: "get"
  });
}

// 冻结 指定司机
export function freezeTeamDriver(query) {
  return request({
    url: `/ntocc-basic-api/driver/freeze`,
    method: "post",
    params: query
  });
}

// 解冻 指定司机
export function unfreezeTeamDriver(query) {
  return request({
    url: `/ntocc-basic-api/driver/unfreeze`,
    method: "post",
    params: query
  });
}

// 获取 指定车队下车辆列表
export function getBindList(query) {
  return request({
    url: `/ntocc-basic-api/vehicle/bindList`,
    method: "get",
    params: query
  });
}

// 绑定 指定车辆
export function bindVehicle(query) {
  return request({
    url: `/ntocc-basic-api/driver/bindVehicle`,
    method: "post",
    params: query
  });
}

// 解绑 指定车辆
export function unbindVehicle(query) {
  return request({
    url: `/ntocc-basic-api/driver/unbindVehicle`,
    method: "post",
    params: query
  });
}

// 新增/更新 车队车辆
export function addOrUpdateVehicle(query) {
  return request({
    url: `/ntocc-basic-api/vehicle/addOrUpdate`,
    method: "post",
    params: query
  });
}

// 获取 车队车辆
export function getVehicle(code) {
  return request({
    url: `/ntocc-basic-api/vehicle/${code}`,
    method: "get"
  });
}

// 删除 车队车辆
export function delVehicle(query) {
  return request({
    url: `/ntocc-basic-api/vehicle/`,
    method: "delete",
    params: query
  });
}

// 冻结 车队车辆
export function freezeVehicle(query) {
  return request({
    url: `/ntocc-basic-api/vehicle/freeze`,
    method: "post",
    params: query
  });
}

// 解冻 车队车辆
export function unfreezeVehicle(query) {
  return request({
    url: `/ntocc-basic-api/vehicle/unfreeze`,
    method: "post",
    params: query
  });
}

// 获取 司机列表
export function getInviteDriverList(query) {
  return request({
    url: "/ntocc-basic-api/driver/inviteDriverList",
    method: "get",
    params: query
  });
}

// 邀请 司机加入
export function inviteDriver(query) {
  return request({
    url: "/ntocc-basic-api/inviteApplyRecord/batchInvite",
    method: "post",
    params: query
  });
}

// 获取 邀请列表
export function getInviteApplyList(query) {
  return request({
    url: "/ntocc-basic-api/inviteApplyRecord/inviteApplyList",
    method: "get",
    params: query
  });
}

// 获取 当前登陆详情
export function getDriverInfo(query) {
  return request({
    url: "/ntocc-basic-api/driver/driverInfo",
    method: "get",
    params: query
  });
}

// 车队管理-删除司机
export function batchDelFromTeam(query) {
  return request({
    url: `/ntocc-basic-api/driver/batchDelFromTeam`,
    method: "delete",
    params: query
  });
}

// 平台车辆冻结
export function freezeDriver(query) {
  return request({
    url: `/ntocc-basic-api/driver/freezeDriver`,
    method: "post",
    params: query
  });
}

// 开通找油网账户
export function openZhaoYou(query) {
  return request({
    url: `/ntocc-tps-api/zhaoYou/open`,
    method: "post",
    params: query
  });
}
// 获取打印图片
export function vehicleQrCode(query) {
  return request({
    url: "/ntocc-basic-api/vehicle/vehicleQrCode",
    method: "get",
    params: query
  });
}
// 平台车辆进行ETC备案
export function registerVehicle(query) {
  return request({
    url: `/ntocc-tms-api/etc/registerVehicle`,
    method: "post",
    params: query
  });
}
// 平台车辆批量进行ETC备案
export function registerVehicles(query) {
  return request({
    url: `ntocc-tms-api/etc/registerVehicleBatch`,
    method: "post",
    params: query
  });
}

// 上报省平台
export function reportLogink(query) {
  return request({
    url: "/ntocc-basic-api/report/reportDriverAndVehicleInfo",
    method: "put",
    params: query
  });
}
export function reportDriverInfo(query) {
  return request({
    url: "/ntocc-basic-api/report/reportDriverInfo",
    method: "put",
    params: query
  });
}
export function reportVehicleInfo(query) {
  return request({
    url: "/ntocc-basic-api/report/reportVehicleInfo",
    method: "put",
    params: query
  });
}

export function reportHubeiVehicleInfo(query) {
  return request({
    url: "/ntocc-thirdparty-api/huBeiApi/reportVehicleInfo",
    method: "put",
    params: query
  });
}

export function reportTianJinVehicleInfo(query) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportVehicleInfo",
    method: "put",
    params: query
  });
}

export function reportHubeiDriverInfo(query) {
  return request({
    url: "/ntocc-thirdparty-api/huBeiApi/reportDriverInfo",
    method: "put",
    params: query
  });
}

export function reportTianJinDriverInfo(query) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportDriverInfo",
    method: "put",
    params: query
  });
}

// 上报省平台
export function checkTruckExist(query) {
  return request({
    url: "/ntocc-basic-api/vehicle/checkTruckExist",
    method: "put",
    params: query
  });
}
//天津东疆税务开关
export function isTaxOpen(query) {
  return request({
    url: "/ntocc-basic-api/industry/isOpen",
    method: "get",
    params: query
  });
}
// 开通高德账号
export function openAmap(query) {
  return request({
    url: `/ntocc-basic-api/driver/openAmap`,
    method: "post",
    params: query
  });
}

// 获取指定司机信息mobile
export function getByPartyCode(code) {
  return request({
    url: "/ntocc-basic-api/driver/getByPartyCode",
    method: "get",
    params: code
  });
}

// 司机实名认证
export function faceVerify(query) {
  return request({
    url: "/ntocc-basic-api/driver/faceVerify",
    method: "get",
    params: query
  });
}
// 核验审核列表
export function taxAuthList(data) {
  return request({
    url: "/ntocc-basic-api/driver/taxAuthList",
    method: "get",
    params: data
  });
}

// 核验审核列表
export function updateTaxAuth(data) {
  return request({
    url: "/ntocc-basic-api/driver/updateTaxAuth",
    method: "put",
    data
  });
}
// 核验审核列表
export function verifyIdentityOnOff(query) {
  return request({
    url: "/ntocc-basic-api/driver/verifyIdentityOnOff",
    method: "get",
    params: query
  });
}

// 彩虹糖
// 彩虹糖司机审核列表
export function rainbowDriverList(query) {
  return request({
    url: "/ntocc-basic-api/driver/listAuthRainbow",
    method: "get",
    params: query
  });
}
// 彩虹糖司机审核
export function rainbowDriverVerify(query) {
  return request({
    url: "/ntocc-basic-api/driver/updateAuthStatusRainbow",
    method: "post",
    params: query
  });
}
// 彩虹糖车辆审核列表
export function rainbowVehicleList(query) {
  return request({
    url: "/ntocc-basic-api/vehicle/listAuthRainbow",
    method: "get",
    params: query
  });
}
// 彩虹糖车辆审核
export function rainbowVehicleVerify(query) {
  return request({
    url: "/ntocc-basic-api/vehicle/auth",
    method: "post",
    params: query
  });
}
// 彩虹糖司机比对列表
export function driverCompareList(query) {
  return request({
    url: "/ntocc-basic-api/driver/listCompareDriver",
    method: "get",
    params: query
  });
}
// 彩虹糖车辆审核列表
export function vehicleCompareList(query) {
  return request({
    url: "/ntocc-basic-api/vehicle/listCompareVehicle",
    method: "get",
    params: query
  });
}

// 彩虹糖司机比对列表
export function driverCompareInfo(query) {
  return request({
    url: "/ntocc-tms-api/rainbowDriver/compareInfoByRainbowDriverCode",
    method: "get",
    params: query
  });
}

// 彩虹糖司机比对列表
export function rainbowDriverPush(query) {
  return request({
    url: "/ntocc-tms-api/rainbowDriver",
    method: "get",
    params: query
  });
}

// 彩虹糖司机比对信息保存
export function rainbowDriverSave(query) {
  return request({
    url: "/ntocc-tms-api/rainbowDriver/compareSave",
    method: "put",
    params: query
  });
}

// 彩虹糖司机比对列表
export function vehicleCompareInfo(query) {
  return request({
    url: "/ntocc-tms-api/rainbowVehicle/compareInfoByRainbowVehicleCode",
    method: "get",
    params: query
  });
}

// 彩虹糖车辆比对列表
export function rainbowVehiclePush(query) {
  return request({
    url: "/ntocc-tms-api/rainbowVehicle",
    method: "get",
    params: query
  });
}

// 彩虹糖司机比对信息保存
export function rainbowVehicleSave(query) {
  return request({
    url: "/ntocc-tms-api/rainbowVehicle/compareSave",
    method: "put",
    params: query
  });
}

// 车辆比对信息
export function vehicleInfor(query) {
  return request({
    url: "/ntocc-tms-api/rainbowVehicle/compareInfo",
    method: "get",
    params: query
  });
}

// 彩虹糖司机比对信息保存
export function driverInfor(query) {
  return request({
    url: "/ntocc-tms-api/rainbowDriver/compareInfoByOrderCode",
    method: "get",
    params: query
  });
}

// 司机列表获取车辆列表
export function rainbowNotBidList(query) {
  return request({
    url: "/ntocc-basic-api/vehicle/rainbowNotBidList",
    method: "get",
    params: query
  });
}
// 司机列表获取车辆列表
export function driverBindVehicle(query) {
  return request({
    url: "/ntocc-basic-api/driver/independenceDriverbindVehicle",
    method: "post",
    params: query
  });
}
// 判断独立司机是否加入车队
export function IsDriverInTeam(query) {
  return request({
    url: "/ntocc-basic-api/driver/verifyDriverJoinTeam",
    method: "get",
    params: query
  });
}

//创建托运人虚拟账号
export function syncMemName(data) {
  return request({
    url: `/ntocc-basic-api/driver/syncMemName`,
    method: "get",
    params: data
  });
}

export function deleteUser(query) {
  return request({
    url: "/ntocc-basic-api/driver/deleteUser",
    method: "post",
    params: query
  });
}

// 查询开户行信息
export function getBankInfo(data) {
  return request({
    url: `/ntocc-basic-api/shipment/getBankInfo`,
    method: "get",
    params: data
  });
}

// 修改开户行信息
export function updateBankInfo(data) {
  return request({
    url: "/ntocc-basic-api/shipment/updateBankInfo",
    method: "post",
    data: data
  });
}

// 查询运单
export function getInfoByCode(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/getInfoByCode`,
    method: "get",
    params: data
  });
}

// 查询运单装卸货地址及行政区划编码
export function getOrderAddress(data) {
  return request({
    url: "/ntocc-tms-api/order/orderAddress",
    method: "get",
    params: data
  });
}

// 修改运单装卸货行政区划编码
export function updateOrderAddressSubdivisionCode(data) {
  return request({
    url: "/ntocc-tms-api/order/orderAddress/subdivisionCode",
    method: "put",
    data
  });
}

// 运单修改
export function updateInfoByCode(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/updateInfoByCode",
    method: "post",
    data: data
  });
}

export function getImgInfo(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/getImgInfo`,
    method: "get",
    params: data
  });
}

export function updateImgInfo(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/updateImgInfo",
    method: "post",
    data: data
  });
}

export function recoverDeletedDriver(data) {
  return request({
    url: `/ntocc-basic-api/driver/recoverDeletedDriver`,
    method: "get",
    params: data
  });
}
//

// export function unbindVehicle(data) {
//   return request({
//     url: "/ntocc-basic-api/driver/unbindVehicle",
//     method: "post",
//     data: data
//   });
// }

export function transferFeeAccount(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/transferFeeAccount",
    method: "post",
    data: data
  });
}

export function getPendingMoney(data) {
  return request({
    url: "/ntocc-basic-api/shipment/getPendingMoney",
    method: "post",
    params: data
  });
}

export function moneyReturn(data) {
  return request({
    url: "/ntocc-basic-api/shipment/moneyReturn",
    method: "post",
    params: data
  });
}

// 清分 /shipment/clearPendingFunds
export function clearPendingFunds(data) {
  return request({
    url: "/ntocc-basic-api/shipment/clearPendingFunds",
    method: "post",
    data: data
  });
}

// 查询托运人账号
export function shipmentInfo(data) {
  return request({
    url: `/ntocc-basic-api/shipment`,
    method: "get",
    params: data
  });
}

// 删除托运人账号
export function deleteShipment(data) {
  return request({
    url: `/ntocc-basic-api/shipment/deleteShipment`,
    method: "post",
    params: data
  });
}

//
export function updateCompanyInfo(data) {
  return request({
    url: `/ntocc-basic-api/shipment/updateCompanyInfo`,
    method: "post",
    data: data
  });
}

// 获取手机号登录白名单
export function getPhoneWhiteList(data) {
  return request({
    url: `/ntocc-basic-api/shipment/getPhoneWhiteList`,
    method: "get",
    params: data
  });
}

// 删除手机号登录白名单
export function deletePhoneWhite(data) {
  return request({
    url: `/ntocc-basic-api/shipment/deletePhoneWhite`,
    method: "post",
    params: data
  });
}

// 获取司机银行卡信息
//   GET /ntocc-basic-api/fundFreezeRecord/getAccountList
//   接口ID：434431273
//   接口地址：https://app.apifox.com/link/project/4415659/apis/api-434431273
export function getAccountList(data) {
  return request({
    url: `/ntocc-basic-api/fundFreezeRecord/getAccountList`,
    method: "get",
    params: data
  });
}

// 资金冻结
//   POST /ntocc-basic-api/fundFreezeRecord/freezeFunds
//   接口ID：434433125
//   接口地址：https://app.apifox.com/link/project/4415659/apis/api-434433125
export function freezeFunds(data) {
  return request({
    url: `/ntocc-basic-api/fundFreezeRecord/freezeFunds`,
    method: "post",
    data: data
  });
}

// 资金解冻
//   GET /ntocc-basic-api/fundFreezeRecord/unFreezeFunds
//   接口ID：434433619
//   接口地址：https://app.apifox.com/link/project/4415659/apis/api-434433619
export function unFreezeFunds(data) {
  return request({
    url: `/ntocc-basic-api/fundFreezeRecord/unFreezeFunds`,
    method: "get",
    params: data
  });
}

// 查询资金冻结列表
// GET /ntocc-basic-api/fundFreezeRecord
// 接口ID：434437673
// 接口地址：https://app.apifox.com/link/project/4415659/apis/api-434437673
export function getFundFreezeRecordList(data) {
  return request({
    url: `/ntocc-basic-api/fundFreezeRecord`,
    method: "get",
    params: data
  });
}

// 司机注册/注销记录列表
export function getDriverRegisterLogList(query) {
  return request({
    url: "/ntocc-basic-api/driverRegisterLog",
    method: "get",
    params: query
  });
}
